import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Navbar from "./Navbar"
import WhatsappButton from "./WhatsappButton";
// import Transitions from "./Transitions";


const Layout = ()=>{
    const location = useLocation();
    return(
        <>
            <Navbar location={location.pathname} />
                {/* <Transitions> */}
                    <div className="min-h-screen">
                        <Outlet/>
                    </div>
                {/* </Transitions> */}
                <div className="fixed sm:bottom-10 sm:right-10 bottom-2 right-2">
                    <WhatsappButton/>
                </div>
            <Footer/>
        </>
    )
}

export default Layout;